import { render, staticRenderFns } from "./aiChat copy.vue?vue&type=template&id=7366ae1c&scoped=true"
import script from "./aiChat copy.vue?vue&type=script&lang=js"
export * from "./aiChat copy.vue?vue&type=script&lang=js"
import style0 from "./aiChat copy.vue?vue&type=style&index=0&id=7366ae1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7366ae1c",
  null
  
)

export default component.exports